import React, { Component } from 'react';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Function} onSelect
 * @prop {Object} option
 * @prop {Object|null} selected
 *
 * @augments {Component<Props>}
 */
export default class Option extends Component {
	handleOnSelect = (e) => {
		e.preventDefault();
		this.props.onSelect(this.props.option.key);
	};

	render () {
		const { selected, option } = this.props;

		return (
			<li
				className={`option ${
					selected && selected.key === option.key ? 'selected' : ''
				}`}
				onClick={this.handleOnSelect}
			>
				{option.value}
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/Option/Option.js